<template>
    <div class="container-fluid">

        <div v-if="alerta">

            <div v-if="cliente">

                <div class="row">
                    <div class="col-md-12" v-if="veiculo">
                        <span style="font-size: 18px">
                            CLIENTE: <b>{{cliente.nome}}</b>
                        </span>
                        <span style="font-size: 16px; font-weight: bold" class="text-danger" v-if="veiculo.oficina">
                            &nbsp;&nbsp; EM OFICINA
                        </span>
                            <span style="font-size: 16px; font-weight: bold" class="text-danger" v-if="veiculo.sinistro">
                            &nbsp;&nbsp; EM MANUTENÇÃO
                        </span>
                        <br/>
                        <span style="font-size: 15px">
                            PLACA: <b>{{alerta.placa}}</b> &nbsp;&nbsp; - &nbsp;&nbsp;
                            EVENTO: <b>{{alerta.titulo}}</b> &nbsp;&nbsp; - &nbsp;&nbsp;
                            DATA DA OCORRÊNCIA: <b>{{alerta.date_time_gps | date("DD/MM/YYYY HH:mm:ss")}}</b>
                        </span><br/>
                        <span style="font-size: 15px" v-if="rastreador">
                            <b class="text-uppercase">{{rastreador.cod_fab_rastreadores}}</b> &nbsp;&nbsp;&nbsp;
                            Marca: <b class="text-uppercase">{{ veiculo.marca }}</b> &nbsp;&nbsp;&nbsp;
                            Modelo:<b class="text-uppercase"> {{ veiculo.modelo }}</b> &nbsp;&nbsp;&nbsp;
                            Ano:<b class="text-uppercase"> {{ veiculo.ano }}</b> &nbsp;&nbsp;&nbsp;
                            Chassi:<b class="text-uppercase"> {{ veiculo.chassi }}</b> &nbsp;&nbsp;&nbsp;
                            Renavam:<b class="text-uppercase"> {{ veiculo.renavan }}</b> &nbsp;&nbsp;&nbsp;
                            Cor:<b class="text-uppercase"> {{ veiculo.cor }}</b> &nbsp;&nbsp;&nbsp;

                            SERIAL: <b class="text-uppercase">{{ rastreador.serial }}</b>
                        </span>
                    </div>
                </div>
            </div>

            <br/>

            <vk-tabs>

                <vk-tabs-item title="POSIÇÃO DO EVENTO">
                    <positions-maps :posicao="posicao"/>
                </vk-tabs-item>

                <vk-tabs-item title="POSIÇÃO ATUAL">
                    <positions-maps :posicao="posicaoAtual"/>
                </vk-tabs-item>

                <vk-tabs-item title="ATENDIMENTO">
                    <form class="form-horizontal">
                        <div class="form-group">
                            <label for="texto" class="col-sm-2 control-label">OBS INTERNA:</label>
                            <div class="col-sm-10">
                                <textarea style="height: 100px !important;" v-model="atendimento.obs_interna" class="form-control" id="texto" ></textarea>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="obs_cliente" class="col-sm-2 control-label">OBS EXTERNA:</label>
                            <div class="col-sm-10">
                                <textarea style="height: 100px !important;" v-model="atendimento.obs_cliente" class="form-control" id="obs_cliente" ></textarea>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="nome_contato" class="col-sm-2 control-label">COM QUEM FALOU?:</label>
                            <div class="col-sm-10">
                                <input type="text" v-model="atendimento.nome_contato" class="form-control" id="nome_contato" >
                            </div>
                        </div>
                        <div class="form-group" v-if="! alerta.resolvido">
                            <div class="col-sm-12 text-right">
                                <button @click="finalizar()" type="button" class="btn btn-sm btn-success">
                                    <li class="fa fa-save"></li> FINALIZAR ATENDIMENTO
                                </button>
                            </div>
                        </div>
                    </form>
                </vk-tabs-item>

                <vk-tabs-item title="PROBLEMAS" v-if="veiculo && ! alerta.resolvido">
                    <problemas  @reload="getVeiculo($event)" :veiculo="veiculo"></problemas>
                </vk-tabs-item>

                <vk-tabs-item title="EVENTOS">
                    <div class="row">
                        <eventos-alertas :id="id"></eventos-alertas>
                    </div>
                </vk-tabs-item>

                <vk-tabs-item title="CLIENTE" v-if="cliente">
                    <dados-do-cliente-admin :cliente="cliente"/>
                </vk-tabs-item>

                <vk-tabs-item title="COMANDOS"  v-if="! alerta.resolvido">

                    <div class="row" style="height : calc(100vh -   280px)">

                        <div class="col-sm-3">
                            <enviar-saidas :id_rastreador="alerta.id_rastreador"/><br/>
                            <reset :id_rastreador="alerta.id_rastreador"/><br/>
                            <solicitar-configuracao :id_rastreador="alerta.id_rastreador"/>
                        </div>

                        <div class="col-sm-9">
                            <table-comandos :id_rastreador="alerta.id_rastreador"/>
                        </div>

                    </div>

                </vk-tabs-item>

            </vk-tabs>

        </div>

    </div>
</template>
<script>

    import FormCliente from '../../components/forms/FormCliente';
    import PosicaoAtual from '../admin/partials/PosicaoAtual.vue';
    import MapPosicao from '../admin/partials/MapPosicao.vue';
    import Reset from '../../components/buttons/Reset.vue';
    import EnviarSaidas from '../../components/buttons/EnviarSaidas';
    import SolicitarConfiguracao from '../../components/buttons/SolicitarConfiguracao.vue';
    import TableComandos from '../../components/tables/TableComandos.vue';
    import {Alerts} from "../../class/alerts"
    import {Rastreador, Veiculo} from "../../class";
    import {date} from "../../filter";
    import {POSITIONS} from "../../mutation-types";
    import EventosAlertas from "./EventosAlertas";
    import { Tracking } from "../../class/tracking";
    import Problemas from "../veiculo/Problemas";
    import TableTelefonesClientes from "../tables/TableTelefonesClientes";
    import DadosDoClienteAdmin from '../admin/partials/DadosDoClienteAdmin.vue';
    import PositionsMaps from '../admin/partials/PositionsMaps.vue';

    export default {
        props: {
            id: null,
        },
        components: {
            PositionsMaps,
            DadosDoClienteAdmin,
            TableTelefonesClientes,
            Problemas,
            EventosAlertas,
            PosicaoAtual, MapPosicao, Reset, EnviarSaidas,
            SolicitarConfiguracao, TableComandos, FormCliente
        },
        data () {
            return {
                alerta: null,
                cliente: null,
                veiculo: null,
                rastreador: null,
                posicao: null,
                atendimento: {
                    nome_contato: null,
                    obs_interna: null,
                    obs_cliente: null,
                    id_alertas: null
                }
            }
        },
        filters: {
            date
        },

        beforeMount() {
            this.load(this.id);
        },

        computed: {
            posicaoAtual () {
                return this.$store.getters.getByRastreador(this.alerta.id_rastreador)
            }
        },
        methods: {
            async loadDetails (id) {
                try {
                    this.details = await Alerts.details(id);
                } catch (e) {
                    console.error(e);
                }
            },

            async load(id) {
                try {
                    this.alerta = await Alerts.byPK(id);

                    this.atendimento.id_alertas = Number(id);

                    if (this.alerta.resolvido && this.alerta.atendimento) {
                        this.atendimento.obs_interna = this.alerta.atendimento.obs_interna;
                        this.atendimento.obs_cliente = this.alerta.atendimento.obs_cliente;
                        this.atendimento.nome_contato = this.alerta.atendimento.nome_contato;
                    }

                    if (this.alerta.cliente) {
                        this.cliente = this.alerta.cliente;
                    }

                    if (this.alerta.id_rastreador) {
                        this.loadPosicao(this.alerta.id_rastreador)
                    }

                    if (this.alerta.veiculo) {
                        this.veiculo = this.alerta.veiculo;
                    }

                } catch (err) {
                    console.error(err);
                }
            },

            async getVeiculo(){
                this.rastreador = await Rastreador.byPK(this.alerta.id_rastreador);
                if (this.veiculo.id_veiculo) {
                    this.veiculo = await Veiculo.byPK(this.veiculo.id_veiculo);
                }
            },

            async finalizar () {
                await Alerts.finalizar(this.atendimento);
                this.$emit('saved');
            },

            async loadPosicao(id_rastreador){
                await this.$store.dispatch(POSITIONS.BY_PK, id_rastreador);
                this.posicao = await Tracking.byPK(this.alerta.id_tracking);
                this.getVeiculo();
                this.$forceUpdate();
            }
        }
    }
</script>
